import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  model
} from '@angular/core';
import { MatAnchor } from "@angular/material/button";
import { MatCheckbox, MatCheckboxChange } from "@angular/material/checkbox";
import { MatIcon } from "@angular/material/icon";
import { WildberriesProductCardData } from "../../types/product-card-group-modal.types";
import { displayProductItemData } from "../../configs/product-card-group-item-config";
import { SnackbarService } from "../../../../../../../core/services/snackbar.service";

@Component({
  selector: 'div[app-product-card-group-item]',
  imports: [
    MatAnchor,
    MatCheckbox,
    MatIcon
  ],
  templateUrl: './product-card-group-item.component.html',
  styleUrl: './product-card-group-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCardGroupItemComponent {
  wildberriesProductCardData = input.required<WildberriesProductCardData>();
  btnKey = input<string>('');
  selectedData = model<Array<number>>([]);

  private snackbarService: SnackbarService = inject(SnackbarService);

  public readonly displayProductItemData = displayProductItemData;

  public isSelected = computed(() =>
    this.selectedData().includes(this.wildberriesProductCardData().id)
  );
  public photo = computed(() => this.wildberriesProductCardData().photo || 'assets/images/fallback-image.svg');

  public getParamData(key: string): string {
    return this.wildberriesProductCardData()[key]?.toString() || 'Не установлен';
  }

  public handleUpdateChecked(event: MatCheckboxChange): void {
    const completed = event.checked;
    const currentIds = this.selectedData();
    const currentId = this.wildberriesProductCardData().id;
    const isAlreadySelected = currentIds.includes(currentId);

    if (completed && !isAlreadySelected && currentIds.length >= 3) {
      this.snackbarService.infoShowMessage('Максимум можно выбрать 3 товара')
      event.source.checked = false;
      return;
    }

    this.selectedData.update(ids =>
      completed ?
        [ ...ids, currentId ] :
        ids.filter(id => id !== currentId)
    );
  }
}
